// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rO","title":"rP","year":"rQ","genres":"rR","buttonWrapper":"rS","button":"rT tz"};